
import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-consultation-confirmation-dialog',
    standalone: true,
    imports: [MatDialogModule, MatButtonModule, MatIconModule],
    template: `
    <h2 mat-dialog-title>Consultation Request</h2>
    <mat-dialog-content>
      <p>
        The patient's clinical data from the current encounter, including:
      </p>
      <ul>
        <li>Past Diagnosis</li>
        <li>Medication Requests</li>
        <li>Vaccinations</li>
        <li>Allergies</li>
      </ul>
      <p>
        will be forwarded to <strong>{{ data.practitionerName }}</strong>.
      </p>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="gap-10">
      <button mat-button (click)="onCancel()">Cancel</button>
      
      <!-- <button mat-stroked-button color="primary" (click)="onConsultOnly()">
        Consult with {{ data.practitionerName }}
      </button> -->

      <button mat-flat-button color="primary" (click)="onConsultAndAppoint()">
        Proceed to Schedule Appointment
      </button>
    </mat-dialog-actions>
  `,
    styles: [`
    ul {
      margin-top: 8px;
      margin-bottom: 16px;
      padding-left: 20px;
    }
    li {
      margin-bottom: 4px;
    }
    .gap-10 {
        gap: 10px;
    }
  `]
})
export class ConsultationConfirmationDialogComponent {
    readonly dialogRef = inject(MatDialogRef<ConsultationConfirmationDialogComponent>);
    readonly data = inject<{ practitionerName: string }>(MAT_DIALOG_DATA);

    onCancel(): void {
        this.dialogRef.close();
    }

    onConsultOnly(): void {
        this.dialogRef.close('consult-only');
    }

    onConsultAndAppoint(): void {
        this.dialogRef.close('consult-appointment');
    }
}
